import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_label_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_label_hdr: fromDatatype.GuidDataFieldInterface;
  header_table: fromDatatype.VarcharDatatypeInterface;
  line_table: fromDatatype.VarcharDatatypeInterface;
  guid_hdr: fromDatatype.GuidDataFieldInterface;
  guid_line: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_label_link_RowClass
  implements bl_fi_mst_label_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_label_hdr: fromDatatype.GuidDataFieldInterface;
  header_table: fromDatatype.VarcharDatatypeInterface;
  line_table: fromDatatype.VarcharDatatypeInterface;
  guid_hdr: fromDatatype.GuidDataFieldInterface;
  guid_line: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
